import Vue from 'vue'
const state = {
  mapSettingInfo: {},
  selectDepartment: {},
  peopleTaskType: false, // 列表开关
  peopleTaskSelect: null // 群防任务选中
}
const getters = {
  selectDepartment(state) {
    return state.selectDepartment
  },
  peopleTaskType(state) {
    return state.peopleTaskType
  },
  peopleTaskSelect(state) {
    return state.peopleTaskSelect
  },
  mapSettingInfo(state) {
    return state.mapSettingInfo || {}
  },
  satelliteMap(state) {
    return state.mapSettingInfo.satelliteMap
  },
  waterSourcePoint(state) {
    return state.mapSettingInfo.waterSourcePoint
  },
  selectWaterSourcePoint(state) {
    return state.mapSettingInfo.selectWaterSourcePoint
  },
  fireControlOffice(state) {
    return state.mapSettingInfo.fireControlOffice
  },
  selectFireControlOffice(state) {
    return state.mapSettingInfo.selectFireControlOffice
  },
  selectPatrolPoint(state) {
    return state.mapSettingInfo.selectPatrolPoint
  },
  deviceTypeEditType(state) {
    return state.mapSettingInfo.deviceTypeEditType
  },
  orgTypeListEditType(state) {
    return state.mapSettingInfo.orgTypeListEditType
  },
  orgTypeListSelect(state) {
    return state.mapSettingInfo.orgTypeListSelect
  },
  deviceTypeSelect(state) {
    return state.mapSettingInfo.deviceTypeSelect
  },
  deviceJobSelect(state) {
    return state.mapSettingInfo.deviceJobSelect
  },
  deviceGenderSelect(state) {
    return state.mapSettingInfo.deviceGenderSelect
  },
  deviceIconType(state) {
    return state.mapSettingInfo.deviceIconType
  },
  iconDisplay(state) {
    return state.mapSettingInfo.iconDisplay
  },
  traffic(state) {
    return state.mapSettingInfo.traffic
  },
  patrolPointType(state) {
    return state.mapSettingInfo.patrolPointType
  },
  showOnlineOnly(state) {
    return state.mapSettingInfo.showOnlineOnly
  },
  displayDeviceContent(state) {
    return state.mapSettingInfo.displayDeviceContent
  },
  treeRadioMode(state) {
    return state.mapSettingInfo.treeRadioMode
  },
  railMapDisplayList(state) {
    return [...state.mapSettingInfo.railMapDisplayList]
  }
}
const mutations = {
  setSelectDepartment(state, selectDepartment) {
    state.selectDepartment = selectDepartment
  },
  // 设置群防任务开关
  setPeopleTaskType(state, peopleTaskType) {
    state.peopleTaskType = peopleTaskType
  },
  // 设置群防任务选中
  setPeopleTaskSelect(state, peopleTaskSelect) {
    state.peopleTaskSelect = peopleTaskSelect
  },
  setMapSettingInfo(state, form) {
    state.mapSettingInfo = form
  },
  setMapSettings(state, obj) {
    Vue.prototype.mainStore.commit('setMapSettings', obj)
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
